import { useAnalyticsContext } from '../providers/AnalyticsProvider';
import { useAnalyticsReportQuery } from '../queries/useAnalyticsReportQuery';
import { getExternalSource } from '../utils/getExternalSource';
import { useAnalyticsCardLegend } from './useAnalyticsCardLegend';
import { useAnalyticsQueryParams } from './useAnalyticsQueryParams';
import { useReportLink } from './useReportLink';
export const useAnalyticsReportBase = ({ reportId, filters }) => {
    const { isLoading: isReportDefinitionLoading, getReportDefinition } = useAnalyticsContext();
    const analyticsQueryParams = useAnalyticsQueryParams();
    const reportDefinition = getReportDefinition(reportId);
    const { analyticsReportQuery } = useAnalyticsReportQuery([{ id: reportId }, { ...analyticsQueryParams, ...filters }], {
        enabled: !!reportDefinition,
    });
    const reportData = analyticsReportQuery?.data;
    const reportLink = useReportLink(reportId);
    const legend = useAnalyticsCardLegend();
    const activeColumn = reportDefinition?.columns.find((column) => column.key === reportDefinition?.yAxisDefaultValue);
    return {
        analyticsReportQuery,
        reportDefinition,
        reportData,
        reportLink,
        legend,
        activeColumn,
        emptyMessage: 'No data found in this date range',
        externalSource: getExternalSource(reportDefinition?.dataSource),
        isReportDefinitionLoading,
        isReportDataLoading: analyticsReportQuery.isLoading,
    };
};
